var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutlineIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 89,
    viewBox: "0 0 160 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.77799 22.4606L4.77655 22.4599C3.45702 21.7866 2.38484 20.6968 1.72284 19.3505C1.06082 18.0042 0.845503 16.4755 1.11015 14.9934C1.85701 10.8443 3.65918 5.8047 7.83993 2.84406C8.84507 2.14318 10.0152 1.7283 11.2292 1.64092C12.4443 1.55346 13.6609 1.79713 14.7533 2.34758L14.7533 2.3476L14.7587 2.35026L139.803 64.4219C139.804 64.4226 139.805 64.4233 139.807 64.424C140.188 64.6184 140.533 64.8811 140.825 65.2002L140.825 65.2005L157.683 83.6315C157.975 83.9512 158.17 84.353 158.24 84.7871C158.311 85.2214 158.254 85.6667 158.076 86.0671C157.899 86.4673 157.611 86.8034 157.25 87.0352C156.889 87.2666 156.471 87.3844 156.046 87.3756C156.046 87.3756 156.045 87.3756 156.045 87.3756L130.616 86.749L130.615 86.749C129.671 86.7269 128.735 86.5759 127.831 86.3C117.236 82.639 92.1505 69.597 66.804 55.9683C56.3433 50.3436 45.8491 44.6253 36.3434 39.4455C22.8616 32.0992 11.368 25.8362 4.77799 22.4606Z",
    fill: "#FE6571",
    stroke: "#082C4E",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M154.842 79.8779C152.898 80.9654 151.209 84.9465 150.845 87.5821",
    stroke: "#082C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M138.475 63.5845C132.135 70.6251 128.32 78.8822 129.065 86.439",
    stroke: "#082C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0932 3.5376C10.7707 7.44498 6.26564 15.7021 4.92139 22.2267",
    stroke: "#082C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlineIcon1);
export default __webpack_public_path__ + "static/media/outline-icon1.c38956bfc0a52ace9c583804aad9c230.svg";
export { ForwardRef as ReactComponent };